module.exports = __webpack_public_path__ + "img/15.70369d21.jpg";